import { doGet } from "./request";
export const downloadFile = async ({ fileType, districtId }) => {
  try {
    const data = await doGet(`/datatable/getData?districtId=${districtId}`);
    const { data: propertiesData } = data?.data;
    if (propertiesData?.length) {
      let headers = [
        "District,Tehsil,Qanoongoi,Mouza,Classification,Location,Khasra No,Dc Rate, Units Of Measure, Structure Rate(Sq.ft),Circle,Zone,Highway Name,Highway Code,Effect From,Last Updated",
      ];

      let properties = propertiesData.reduce((acc, property) => {
        const {
          District,
          Tehsil,
          Qanoongoi,
          Mouza,
          Classification,
          Location,
          Circle,
          Zone,
        } = property;
        acc.push(
          [
            District,
            Tehsil,
            Qanoongoi,
            Mouza,
            Classification,
            Location,
            property?.["Khasra Number"],
            property?.["Dc Rate"],
            property?.["Units Of Measure"] ?? "Marla(s)",
            property?.["Structure Rate"],
            Circle,
            Zone,
            property?.["Highway Name"],
            property?.["Highway Code"],
            property?.effect_from,
            property?.["Last Updated"],
          ].join(",")
        );
        return acc;
      }, []);
      const blob = new Blob([[...headers, ...properties].join("\n")], {
        type: fileType,
      });
      const a = document.createElement("a");
      a.download = propertiesData?.[0]?.District;
      a.href = window.URL.createObjectURL(blob);
      const clickEvt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
      });
      a.dispatchEvent(clickEvt);
      a.remove();
    }
  } catch (error) {
    console.error(error);
  }
};
